import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ConfirmButton = styled.button<Props>`
  background: ${(props) =>
    props.focused
      ? Colors['modal']['button']['light']
      : 'rgba(255, 255, 255, 0.5)'};
  border: ${Colors['dark']} ${2 * Screen.widthRatio}px solid;
  border-radius: ${40 * Screen.widthRatio}px;
  color: ${Colors['dark']}};
  cursor: pointer;
  font-family: ${Fonts['regular']};
  font-size: ${(props) =>
    props.fontSize && props.fontSize * Screen.widthRatio}px;
  height: ${(props) => props.height && props.height * Screen.widthRatio}px;
  margin: ${(props) => props.margin || '0px'};
  width: ${(props) => props.width && props.width * Screen.widthRatio}px;
  &:hover {
    background: ${Colors['modal']['button']['light']}
  }
`;

ConfirmButton.defaultProps = {
  width: 350,
  height: 80,
  fontSize: 34,
  focused: true,
};

export default ConfirmButton;
